import type { SubmissionCoverageDto } from './submission-coverages.types';
import { QuoteAgencyStatus } from '../../types/common/misc';

export const QUOTE_STATUS_POLL_INTERVAL_MS = 5000;

// fir-account rates a REQUESTED quote asynchronously and flips it to READY (or REFERRED/declined)
// with nothing pushed to the client, so a status badge reading this data is stuck on REQUESTED
// until something refetches it. Checked on both the option's primary quote and its `quotes`
// history, since either can still be the one sitting REQUESTED (FPX-7539 lets an option carry
// more than one quote). Shared by every query that surfaces coverage-option quote status, so a
// caller can poll with `refetchInterval: (data) => hasRequestedQuote(data) ? ... : false`.
export const hasRequestedQuote = (data?: SubmissionCoverageDto): boolean =>
  !!data?.coverageOptions?.some(
    (option) =>
      option.quoteStatus === QuoteAgencyStatus.REQUESTED ||
      !!option.quotes?.some(
        (quote) => quote.quoteStatus === QuoteAgencyStatus.REQUESTED
      )
  );
